import React from "react";
import { Container } from "react-bootstrap";
import {EmptyStateContainer} from "./style";
import { FiAlertTriangle } from "react-icons/fi";
const EmptyState = ({ message }) => {
  return (
    <EmptyStateContainer>
      <Container>
        <FiAlertTriangle className="icon" />
        <div className="message">{message}</div>
      </Container>
    </EmptyStateContainer>
  );
};
export default EmptyState;
